import styled from "@emotion/styled"
import { PTag, PText } from "@porsche-design-system/components-react"
import { spacingStaticMd, spacingStaticSm, spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import type { EquipmentView } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage, defineMessages } from "react-intl"
import { ExteriorColorTile, InteriorColorTile } from "src/components"

const messages = defineMessages({
	onlyVisibleInternally: {
		defaultMessage: "only visible internally",
		id: "equipment.onlyVisibleInternally",
	},
})

export const EquipmentText = ({ color, name, optionCode, visibleForCustomers }: EquipmentView) => (
	<Wrapper>
		{optionCode && <OptionCode color="contrast-medium">{optionCode}</OptionCode>}
		<Description>
			<Name>{name}</Name>
			{color && (
				<ColorWrapper>
					{color.hexCodes.length > 1 ? (
						<InteriorColorTile seatColor={color.hexCodes[0]} cockpitColor={color.hexCodes[1]} />
					) : (
						<ExteriorColorTile color={color.hexCodes[0]} glossy={false} />
					)}
				</ColorWrapper>
			)}
			{!visibleForCustomers && (
				<VisibilityTag variant="info-frosted" compact>
					<FormattedMessage {...messages.onlyVisibleInternally} />
				</VisibilityTag>
			)}
		</Description>
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	align-items: flex-start;
	margin-bottom: ${spacingStaticXs};
`

const Description = styled.div`
	display: inline;
	gap: ${spacingStaticXs};
`

const Name = styled.span`
	display: inline;
	height: 30px;
`

const ColorWrapper = styled.div`
	display: inline-flex;
	margin-top: -${spacingStaticXs};
	vertical-align: middle;
	margin-inline-start: ${spacingStaticSm};
 	gap: ${spacingStaticXs};
`

const VisibilityTag = styled(PTag)`
	margin-inline-start: ${spacingStaticSm};
`

const OptionCode = styled(PText)`
	min-width: 35px;
	margin-inline-end: ${spacingStaticMd};
`
